<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="名称" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入动作名称"></el-input>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" :disabled="drawDone"
                    @click="drawCoordinate">绘制</el-button>
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">创建</el-button>
                <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import DrawHelper from "../lib/DrawPoint.js"
let DrawUti = undefined;
import * as Help from "./help"
let plotArr = [];
export default {
    props: ["subData"],
    data() {
        return {
            ruleForm: {
                name: "",
                type: "pointExplot",
                typeName: "爆炸点",
                delay: 1,
                data: "http://data.mars3d.cn/gltf/mars/leida.glb",
                coordinate: "",
                params: {},
                view: {}
            },
            rules: {
                name: [
                    { required: true, message: "请选择围栏类型", trigger: "change" },
                ],
                data: [
                    { required: true, message: "请绘制围栏范围", trigger: "blur" }
                ],
                coordinate: [{ required: true, message: "请绘制围栏范围", trigger: "blur" }]
            },
            drawDone: false,
        };
    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm);
            this.ruleForm.view = Help.getCameraView();
            this.$bus.$emit("addActionObj", JSON.parse(JSON.stringify(this.ruleForm)));
            this.resetForm("ruleForm");
            this.$parent.close();
        },
        resetForm(formName) {
            DrawUti && DrawUti.clear();
            this.$refs[formName].resetFields();
            this.drawDone = false;
            for (let i = 0; i < plotArr.length; i++) {
                plotArr[i].preUpdateEvent && plotArr[i].preUpdateEvent();
                viewer.scene.primitives.remove(plotArr[i]);
            }
        },
        getPlot(plot) {
            this.ruleForm.coordinate = plot.position.getValue();
            this.drawDone = true;

            var entity = Help.addExplotEffect(viewer,plot);
            plotArr.push(entity);
            this.$parent.reset();
        },
        drawCoordinate() {
            if (!DrawUti) {
                DrawUti = new DrawHelper({
                    canEdit: false,
                    callback: this.getPlot
                });
            }

            DrawUti.reset();
            DrawUti.start();
            this.$parent.min();
        }
    },
    created() {
    },
    mounted() { },
    beforeDestroy() {
        this.$refs['ruleForm'].resetFields();
        DrawUti && DrawUti.clear();
        DrawUti = undefined;
        for (let i = 0; i < plotArr.length; i++) {
            viewer.entities.remove(plotArr[i]);
        }
    }
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>